import { DEFAULT_QUANTIFY_TOP_SELECTION_VALUE } from '@modules/quantify/constants';
import { VisualisationType } from '../store/types';

export function getVisibleDataPointsDefaultSize(
  visualisationType: VisualisationType,
  selectionCount?: number,
) {
  switch (visualisationType) {
    case VisualisationType.BAR:
    case VisualisationType.TREND:
    case VisualisationType.PIE:
      return selectionCount ?? DEFAULT_QUANTIFY_TOP_SELECTION_VALUE;
    default:
      return DEFAULT_QUANTIFY_TOP_SELECTION_VALUE;
  }
}
